<template>
  <div class="tab-page">
    <div class="type-wrapper">
      <span
        class="pr-20"
        :class="{ active: type === 'users' }"
        @click="selectType('users')"
        v-if="p('Manage.Users.View')"
      >
        {{ $t('text.users') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'roles' }"
        @click="selectType('roles')"
        v-if="p('Manage.Roles.View')"
      >
        {{ $t('text.roles') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'distributors' }"
        @click="selectType('distributors')"
        v-if="p('Manage.Distributors.View')"
      >
        Distributors
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'devices' }"
        @click="selectType('devices')"
      >
        Devices
      </span>
    </div>
    <UserList v-if="type === 'users'" />
    <RoleList v-if="type === 'roles'" />
    <Distributors v-if="type === 'distributors'" />
    <Devices v-if="type === 'devices'" />
  </div>
</template>

<script>
import UserList from '@/components/manage/UserList'
import RoleList from '@/components/manage/RoleList'
import Distributors from '@/components/manage/Distributors'
import Devices from '@/components/manage/Devices'
export default {
  data() {
    return {
      type: 'users'
    }
  },
  components: {
    UserList,
    RoleList,
    Distributors,
    Devices
  },
  mounted() {
    if (this.$permission('Manage.Users.View')) {
      this.type = 'users'
    } else if (this.$permission('Manage.Roles.View')) {
      this.type = 'roles'
    } else {
      this.type = 'distributors'
    }
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
